<template>
    <div class="w-100 h-100">
        <ul class="list-unstyled d-flex flex-column justify-space-around">
            <li :class="{ active: getBarStatus.applicantsIsActive, }" @click="makeActive('applicantsIsActive')">Applicants</li>
            <li :class="{ active: getBarStatus.nonApplicantIsActive, }" @click="makeActive('nonApplicantIsActive')">Non Applicant</li>
            <li :class="{ active: getBarStatus.registeredIsActive, }" @click="makeActive('registeredIsActive')">Registered</li>
            <li @click="$emit('cancel-dialog')">Cancel</li>
        </ul>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "InfoSessionSideMenu",
        methods: {
            ...mapActions(['setBarStatus', 'setShowList']),
            makeActive(target) {
                this.setBarStatus(target)
                this.setShowList(this.getCurrentInfoSession.infoSessionId)
            }
        },
        computed: {
            ...mapGetters(['getBarStatus', 'getCurrentInfoSession'])
        }
    }
</script>

<style scoped>
    ul {
        height: 480px !important;
    }

    ul > li {
        padding: 20px;
        transition: all .2s ease-in-out;
    }

    ul > li:hover {
        background: #ccca;
        border-radius: 4px;
        font-weight: bold;
        cursor: pointer;
    }

    .active {
        background: #ccca;
        border-radius: 4px;
        font-weight: bold;
    }
</style>